import Container from "@client/content/Containers/container";
import { getContainerProps, getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import Content from "./Content/container";
import CourseModal from "./CourseModal/container";
import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    hasCourse: boolean;
  };

export interface ActionProps {}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container className="wsc_content_member_course_detail" {...getContainerProps(props)}>
      {props.hasCourse ? (
        <>
          <Content {...getEntityRef(props)} />
          <CourseModal {...getRootContainerProps(props)} />
        </>
      ) : props.isEditMode ? (
        i18n.infoMembershipSitesOnly
      ) : null}
    </Container>
  );
};
